export { default } from './PageEventOrganizers.vue'
